import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["metadataId", "templateActions", "templatePagePath", "className", "title", "description", "templateImage", "templateImageForMobile", "previewButton", "actionButtonProps", "accessConstraints", "appSlug", "position", "tags", "metadataId", "newBoardMetadataId"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, Desktop, Heading, Mobile, Portal, Text, useWindowSize } from '@miro-site/core';
import styled from 'styled-components';
import React, { useState } from 'react';
import { useTheme } from 'styled-components';
import ActionsOverlay from './components/ActionsOverlay';
import CardDescription from './components/CardDescription';
import CardImage from './components/CardImage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledHeading = styled(Heading).attrs({
  as: 'div',
  $variant: 'h4',
  $styles: {
    position: 'absolute',
    maxWidth: 168,
    top: 32,
    zIndex: 1
  }
}).withConfig({
  displayName: "HighlightedCard__StyledHeading",
  componentId: "sc-l5c5a6-0"
})(["/*! @noflip */ left:32px;"]);

var HighlightedCard = function HighlightedCard(_ref) {
  var metadataId = _ref.metadataId,
      templateActions = _ref.templateActions,
      templatePagePath = _ref.templatePagePath,
      className = _ref.className,
      title = _ref.title,
      description = _ref.description,
      templateImage = _ref.templateImage,
      templateImageForMobile = _ref.templateImageForMobile,
      previewButton = _ref.previewButton,
      actionButtonProps = _ref.actionButtonProps,
      accessConstraints = _ref.accessConstraints,
      appSlug = _ref.appSlug,
      position = _ref.position,
      tags = _ref.tags,
      _metadataId = _ref.metadataId,
      _newBoardMetadataId = _ref.newBoardMetadataId,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      showDescription = _useState[0],
      setShowDescription = _useState[1];

  var theme = useTheme();
  var windowSize = useWindowSize();
  var isMobileViewport = windowSize.width && windowSize.width < theme.breakpoints.small;

  var _useState2 = useState(false),
      isOverlayVisible = _useState2[0],
      setOverlayVisible = _useState2[1];

  var getContainerHandlers = function getContainerHandlers() {
    if (isMobileViewport) {
      return {
        onClick: function onClick() {
          setOverlayVisible(true);
        }
      };
    }

    return {
      onMouseEnter: function onMouseEnter() {
        return setOverlayVisible(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setOverlayVisible(false);
      }
    };
  };

  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
    className: className
  }, props), {}, {
    children: [/*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
      $styles: {
        position: 'relative',
        height: 0,
        paddingTop: ['64.307%', '59.090%']
      }
    }, getContainerHandlers()), {}, {
      children: [/*#__PURE__*/_jsx(CardImage, {
        onShowCardDescription: function onShowCardDescription() {
          return setShowDescription(true);
        },
        image: _objectSpread(_objectSpread({}, templateImage), {}, {
          width: 550,
          height: 325
        }),
        mobileImage: _objectSpread(_objectSpread({}, templateImageForMobile), {}, {
          width: 325,
          height: 209
        }),
        priority: position === 0,
        wrapperStyles: {
          marginBottom: [12, null, null, null],
          borderRadius: [8, 16, 16, 16],
          position: 'absolute',
          overflow: 'hidden',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'grey'
        }
      }), /*#__PURE__*/_jsxs(Desktop, {
        $block: true,
        children: [/*#__PURE__*/_jsx(StyledHeading, {
          children: title
        }), /*#__PURE__*/_jsx(ActionsOverlay, {
          metadataId: metadataId,
          templateActions: templateActions,
          templatePagePath: templatePagePath,
          previewButton: previewButton,
          actionButtonProps: actionButtonProps,
          onMoreInfoClick: function onMoreInfoClick() {
            return setShowDescription(true);
          },
          isVisible: isOverlayVisible
        })]
      }), isMobileViewport ? /*#__PURE__*/_jsx(Portal, {
        children: /*#__PURE__*/_jsx(CardDescription, {
          metadataId: metadataId,
          templateActions: templateActions,
          templatePagePath: templatePagePath,
          isShown: showDescription,
          isFullscreen: true,
          title: title,
          tags: tags,
          previewButton: previewButton,
          actionButtonProps: actionButtonProps,
          description: description,
          thumbnail: templateImage,
          onClose: function onClose() {
            return setShowDescription(false);
          },
          popupStyles: {
            position: 'fixed',
            top: 0,
            right: 0,
            left: 0,
            height: '100%',
            overflow: 'auto',
            zIndex: 701,
            paddingTop: [64, null, null, null],
            paddingRight: [20, null, null, null],
            paddingBottom: [43, null, null, null],
            paddingLeft: [20, null, null, null]
          }
        })
      }) : /*#__PURE__*/_jsx(CardDescription, {
        metadataId: metadataId,
        templateActions: templateActions,
        templatePagePath: templatePagePath,
        isShown: showDescription,
        previewButton: previewButton,
        actionButtonProps: actionButtonProps,
        title: title,
        tags: tags,
        description: description,
        thumbnail: templateImage,
        onClose: function onClose() {
          return setShowDescription(false);
        },
        descriptionStyles: {
          overflow: 'auto',
          maxHeight: [null, 200, 200, 200]
        },
        popupStyles: {
          position: 'absolute',
          overflow: 'visible',
          width: '100%',
          paddingTop: [null, 40, 40, 40],
          paddingRight: [null, 90, 90, 90],
          paddingBottom: [null, 40, 40, 40],
          paddingLeft: [null, 40, 40, 40],
          top: 0,
          left: 0
        }
      })]
    })), /*#__PURE__*/_jsx(Mobile, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "div",
        $variant: "p1",
        $styles: {
          fontWeight: 700
        },
        children: title
      })
    })]
  }));
};

export default HighlightedCard;